
































import Vue from 'vue';


export default Vue.extend ({
	name: 'block',
	props: [ 'name' ],
	data () {
		return {};
	}
});

